<header class="card-head">
  <h2 class="card-title">A empresa</h2>
  @if (source(); as s) {
    <app-charter-provenance [from]="s" variant="source" [current]="true" />
  }
</header>
<dl class="fields">
  @for (row of rows(); track row.label) {
    <div class="field prov-row" [class.field--wide]="row.wide">
      <dt>{{ row.label }}</dt>
      <dd>
        <span class="field__value">{{ row.value }}</span>
        @if (row.note; as note) {
          <span class="field__note" [class.field__note--warning]="note.tone === 'warning'">
            <i
              class="pi"
              [class.pi-check]="note.tone === 'ok'"
              [class.pi-exclamation-triangle]="note.tone === 'warning'"
              aria-hidden="true"></i>
            {{ note.text }}
          </span>
        }
        @if (row.evidence && row.evidence.value !== null) {
          <app-charter-provenance
            [from]="row.evidence"
            [current]="true"
            variant="icon"
            [base]="source()" />
        }
      </dd>
    </div>
  }
</dl>
